import Module, { moduleInit, ViewLayer, subscribeMsg, implementFunction, bindButtonClickEvent, bindToggleClickEvent } from "../../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../../framework/core/module_manager";
import BullBullConst from "../utils/bullbull_const";
import * as GameProto from "../../net/proto/proto_bullbull_game";
import * as RoomProto from "../../net/proto/proto_bullbull_room";
import Msg from "../../net/bullbull_net_msg_data_game";
import UserDataManager, { IUserCurrencyData } from "../../../../manager/user_manager";
import ModelData from "../../../public/model_data";
import GameServer from "../../../hall/server/gameserver/game_server";
import BankerBullBullTableView from "./banker_bullbull_table_view";
import BankerBullBullTableModel from "./banker_bullbull_table_model";
import SceneManager from "../../../../manager/scene_manager";
import BullBullPlayerInfo from "./bullbull_player_info";
import * as ProtoLogin from "../../../hall/server/hall/proto_hall"
import AppData from "../../../public/const/app_data";
import AudioManager from "../../../../manager/audio_manager";
import LanguageManager from "../../../../manager/language_manager";
import GameMorePanel from "../../../table/module/game_morepanel/game_morepanel";
import { joinUtil, joinResult } from "../../../public/join_util";
import DialogLeave from "../../../public/module/dialog_leave/dialog_leave";
import LoaclStorage from "../../../../manager/local_storage";
import TableBaseModule from "../../../table/module/table_base/table_base_module";
import TablePlayerAvatar from "../../../table/components/table_player_avatar";

const { ccclass ,property} = cc._decorator;

@ccclass
@moduleInit(BullBullConst.TABLE_MODULE_NAME)
export default class BankerBullBullTableModule extends TableBaseModule<BankerBullBullTableView, BankerBullBullTableModel>  {    

    private avatarSeat : number;
    private avatarId : number ;
    private isLeaveRoom : boolean;

    private ackId : number;

    private playerInfoMap : { [key:string ] : BullBullPlayerInfo } = {};   

    private showIconAniIdList : number[] = [];
        
    private timeOffset : number;

    private bankerId : number;

    private comboType : string;
    private pokers : GameProto.BullBullGame.IPoker[];
    private isSelfPokerBack : boolean;    
    private startGame : boolean;

    // 0:房间等待准备状态 1:定庄状态 2:下注状态 3:等待结算状态,5:结算超时 6:牌局重置 8:
    private roomState : number;

    /**
     * 是否为看牌抢庄
     */
    private isWatchAndRob : boolean;    

    
    constructor(){   
        super();

        this.layer = ViewLayer.Low;
        this.viewType = BankerBullBullTableView;
        this.modelType = BankerBullBullTableModel;
        this.windowPrefabResPath = BullBullConst.PREFAB_RES_PATH_BASE + "bullbull_table";
        //
        this.avatarId = ModelData.instance.roleData.id;    

        this.isWatchAndRob = false;
    
        this.reset();
    }

    onShow(intentData : any){
        
        this.showNetPrompt(false);
        this.model.init(GameServer.instance.netClient)
        this.model.clearMsgEvent()
        this.registerMsg();
        this.bindEvent();    
        super.onShow(intentData);    
        AudioManager.instance.playMusic('package/bullbull/audio/bgm/niu_niu', false);

        let playerRules =  ModelData.instance.roomInfo.PlayRuleData;
        if (playerRules) {
            this.isWatchAndRob = playerRules.bankerType == 2 && playerRules.kanPaiCount == 4;    
            this.view.setIsWatchAndRob(this.isWatchAndRob);        
        }
        
        let self = this;

        let userId = ModelData.instance.roleData.id;
        this.avatarId = ModelData.instance.roleData.id;    

        this.getSelfCurrencyData((currencyData: IUserCurrencyData) =>{     
            let number = ModelData.instance.tableCommonData.isClubTable? currencyData.chipClub : currencyData.chip;
            self.view.updatePlayerInfo(0,number.toString(),userId);
        });

        this.updateDizhu();

        this.view.reconnect.node.active = AppData.testMode;        
        
        this.view.setAutoToggle(false);
        
    }

    private get autoShowPoker(){
        
        let value = LoaclStorage.getItem(ModelData.instance.roleData.id.toString() + "_bullbull_auto_show_poker");

        return false; //不需要自动开牌
        //return value == "1";
    }

    private set autoShowPoker(v : boolean){
        
        let key = ModelData.instance.roleData.id.toString() + "_bullbull_auto_show_poker";

        LoaclStorage.setItem(key, v ? "1" : 0);
    }

    private bindEvent(){

        this.eventBind("Event_GoldMatching_Quit", this.on_gold_quit_rsp);
        this.eventBind("Event_GoldMatching_Notify_RoomInfo", this.on_gold_roominfo_notify);        
        //this.eventBind("bullbull_quit_room", this.on_bull_bull_quit_room);
        
        this.eventBind("event_exit_game", this.on_bull_bull_quit_room);

        this.eventBind("event_rob_card_finish",this.on_event_rob_card_finish);

    }


    private on_gold_roominfo_notify(protoData: ProtoLogin.Auth.Notify_GoldRoomInfo) {        
        return;
        if (!protoData.RoomID || protoData.RoomID == 0) {

            for (let index = 0; index < protoData.Players.length; index++) {
                const info = protoData.Players[index];
                
                //找到主角定位置
                if(info.UserID == this.avatarId){

                    this.avatarSeat = info.SeatID;
                    let self = this;

                    let isMangoTable = ModelData.instance.tableCommonData.isClubTable;                                        
                                                  
                    UserDataManager.getCurrencyData(info.UserID,(currencyData : IUserCurrencyData)=>{

                        let number = isMangoTable? currencyData.chip : currencyData.chipClub;
                        self.view.updatePlayerInfo(0,number.toString(),info.UserID);
                    })

                    break;
                }                
            }

            if (protoData.Players.length > 1) {
             
                for (let index = 0; index < protoData.Players.length; index++) {
                    const info = protoData.Players[index];

                    if (info.UserID == 0) continue;
                    
                    if(info.UserID != this.avatarId){
                        this.view.updatePlayerInfo(this.getSeatSide(info.SeatID),"",info.UserID); 
                    }
                    
                }
            }                      
        }
      
    }

    private on_gold_quit_rsp(){

        if (!this.nodeIsActive) {
            return;
        }

        
    }

    private on_bull_bull_quit_room(){
        
        this.model.request_leave_room();

        // if (this.isBattle(this.avatarId)) {
        //     ModuleManager.instance.showModule(DialogLeave)            
        // }else{
        //     this.model.request_leave_room();
        // }        
    }

    private on_event_rob_card_finish(){

        this.view.setLastCardAplha(255);

        this.reqComputerDelay(1);            
    }

    private reqComputerId = 0;
    private reqComputerDelay(time : number){

        let self = this;
        this.reqComputerId = this.doScheduleOnce(()=>{
            self.requset_computePoker()
        },time)
    }

    private cancelComputerReq(){

        this.cancelSchedule(this.reqComputerId);
    }


    @implementFunction('onSelfCurrencyDataUpdate')
    protected onSelfDataUpdate(data: IUserCurrencyData){

        if(!GameServer.instance.netClient.netState ){

            let isMangoTable = ModelData.instance.tableCommonData.isClubTable;        
            this.view.updatePlayerInfo(0,isMangoTable ? String(data.chip) : String(data.chipClub),this.avatarId);
        }        
    }

    

    public hide()
    {
        super.hide();
        this.view.onHide();
    }


    protected onButtonClickName(name : string,customEventData : any,_node:cc.Node){

        switch (name) {
            case "Btn_More":
                ModuleManager.instance.showModule(GameMorePanel);
                break;  
            case "Btn_Continue":                
                break;         
            case "Button_ShowPoker":
                this.requset_computePoker();
                this.view.playSoundInTable("spell_click");
                break;
            case "Button_HaveCow":
                if (this.checkCow() && this.view.checkClickResult() ) {                    
                    this.requset_computePoker();
                }else{
                    this.view.showUncorrectNode(true);
                }
                break;
            case "Button_NoCow":
                if (!this.checkCow()) {
                    this.requset_computePoker();
                }else{
                    this.view.showUncorrectNode(true);
                }
                break;        
            case "Button_RobCard":
                //显示搓牌                

                this.view.showRubbing(true);
                this.view.setLastCardAplha(0);
                this.view.tranferCard();
                this.view.showCowBtn(false);
                break;   
            case "Button_DisplayCard":
                //this.requset_computePoker();
                this.view.showCowBtn(false);
                this.view.tranferCard();                     
                this.reqComputerDelay(1);                
                break;     
            case "Btn_Bet0":
            case "Btn_Bet1":
            case "Btn_Bet2":
            case "Btn_Bet3":                   
                this.model.requset_bet(Number(customEventData));
                break;        
            case "Btn_NoContend":
                this.model.request_banker(0);
                break;                              
            case "Btn_1Times":
                this.model.request_banker(1);
                break;
            case "Btn_2Times":
                this.model.request_banker(2);
                break;
            case "Btn_3Times":
                this.model.request_banker(3);                
                break;                
            case "Button_Reconnect":
                this.model.disconnect();
                break;    
        }
    }

    @bindToggleClickEvent("AutoToggle")
    onAutoToggle(toggle : cc.Toggle){

        this.autoShowPoker = toggle.isChecked;

        this.view.showAutoPoker(true,this.autoShowPoker);
        
    }


    @bindButtonClickEvent("PlayerAvatar")
    onPlayerAvatar(node : cc.Node,data : string){
        
        this.eventDispatch("on_click_player_avatar",node.getComponent(TablePlayerAvatar));
        //this.showEmoji(Number(data));
    }

    private showEmoji(seatSide : number){

        let info = this.getPlayerInfoBySide(seatSide);
        if (info) {
            ModuleManager.instance.showEmojiModule(Number(info.playerId), BullBullConst.TABLE_MODULE_NAME);
        }
    }
   
    getSeatNodeById(playerId:number):cc.Node
    {
        let seatSide = this.getPlayerInfo(playerId).seatSide;

        return this.view.getSeatNodeById(seatSide);
    }


    public requset_computePoker(){
        if (this.roomState == 3) {
            this.model.requset_computePoker();         
        }        
    }

    /**
     * 收到房间信息
     * @param roomData 
     */   
    @subscribeMsg(Msg.SyncRoomInfo)
    private onRecvRoomInfo(roomData : RoomProto.BullBullRoom.SynchronizeBroadcast){
             
        //this.curtPlayerNum = roomData.seatInfoList.length;
        this.isLeaveRoom = false;
        
        for (let index = 0; index < roomData.seatInfoList.length; index++) {
            const seatInfo = roomData.seatInfoList[index];

            if (seatInfo.playerId == this.avatarId){                          
                
                //this.view.showContinueBtn(seatInfo.isReady != 1);

                this.avatarSeat = seatInfo.seatIndex;
                this.view.updatePlayerInfo(0,seatInfo.coinBalanceStr,seatInfo.playerId,"",seatInfo.userJson);

                UserDataManager.balanceChangeMessage(Number(seatInfo.coinBalanceStr));
                break;
            }
        }        

        this.bankerId = 0;
        for (let index = 0; index < roomData.seatInfoList.length; index++) {
            const seatInfo = roomData.seatInfoList[index];                                            

            if(seatInfo.playerId == 0) continue;

            if (seatInfo.isBanker == 1) {
                
                this.bankerId = seatInfo.playerId;                                
            }

            let seatSide = this.getSeatSide(seatInfo.seatIndex);
            this.updateSeatInfo(seatInfo.playerId,seatInfo);                      
            
            this.view.updatePlayerInfo(seatSide,seatInfo.coinBalanceStr,seatInfo.playerId,"",seatInfo.userJson);

        }

        this.roomState = roomData.roomInfo.state;        
        if (this.roomState == 0) {
                        
            //当前所有玩家都进入战斗
            for (const key in this.playerInfoMap) {                
                if (this.playerInfoMap.hasOwnProperty(key)) {
                    const element = this.playerInfoMap[key];                            
                    
                    this.setBattle(element.playerId,true);
                }                
            }
            this.checkWating();            

        }else{

            //有牌的玩家进入战斗
            roomData.seatInfoList.forEach(seatInfo=>{
                
                if (seatInfo.playerId != 0) {
                                 
                    this.setBattle(seatInfo.playerId,seatInfo.gameCnt > 0);

                    if (this.roomState > 1 && this.roomState != 8 ) {
                
                        let seatSide = this.getSeatSide(seatInfo.seatIndex);
                        
                        if(seatInfo.gameCnt  > 0){
                            //只有战斗状态才有
                            if (seatInfo.isBanker) {
                                this.view.showScramble(seatSide,seatInfo.multiple? seatInfo.multiple : 1);    
                            }else{
                                if (this.roomState == 3 || this.roomState == 5 ) {
                                    this.view.showBetResult(seatSide,seatInfo.bet);   
                                }                                
                            }
                        }                                                                   
                    }
                }                            

            });
        }
        let self  = this;

        for (let index = 0; index < roomData.seatInfoList.length; index++) {
            const seatInfo = roomData.seatInfoList[index];            

            if (seatInfo.playerId == this.avatarId){   
                
                //0:房间等待准备状态 1:定庄状态 2:下注状态 3:等待结算状态 5:结算超时 8:游戏已经开始，但还未开始抢庄

                if(this.roomState == 0)
                {
                    //this.view.showContinueBtn(true);                   
                  
                }else if(this.roomState == 8){
                    
                    if (this.isBattle(this.avatarId)) {

                        if (this.isWatchAndRob) {
                            this.view.startDealPoker(this.playerInfoMap,seatInfo.playerId, seatInfo.pokers,seatInfo.comboType,null,true,roomData.roomInfo.state);
                        }

                    }else{
                        if (this.isWatchAndRob){
                            this.view.startDealPoker(this.playerInfoMap,0,[],"",null);
                        }   
                    }
                }
                else if (this.roomState == 1) {
                    
                    this.max_multiple_banker = seatInfo.maxScrambleMultiple;
                   
                    if (this.isBattle(this.avatarId)) {

                        if (this.isWatchAndRob) {
                            this.view.startDealPoker(this.playerInfoMap,seatInfo.playerId,seatInfo.pokers,seatInfo.comboType,null,true,roomData.roomInfo.state);
                        }

                    }else{
                        if (this.isWatchAndRob){
                            this.view.startDealPoker(this.playerInfoMap,0,[],"",null);
                        }
                        
                    }               

                    //this.view.showCountDown(info.expire - this.getServerTimeNow());       

                    //this.lockBanker();
                }                
                else if(this.roomState == 2){                                       

                    if (this.isBattle(this.avatarId)) {

                        if (this.isWatchAndRob) {
                            this.view.startDealPoker(this.playerInfoMap,seatInfo.playerId, seatInfo.pokers,seatInfo.comboType,null,true,roomData.roomInfo.state);
                        }

                        if (this.bankerId != this.avatarId) {
                         
                            this.view.showBetButtons(seatInfo.betPool);
                        }                       

                    }else{
                        if (this.isWatchAndRob) {
                            this.view.startDealPoker(this.playerInfoMap,0,[],"",null);
                        }
                    }
                    
                    //this.lockBanker();

                    //this.view.showCountDown(info.expire - this.getServerTimeNow());       
                                                            
                }
                else if(this.roomState == 3){
                                        
                    if (this.isBattle(this.avatarId)) {
                        this.view.startDealPoker(this.playerInfoMap,seatInfo.playerId,seatInfo.pokers,seatInfo.comboType,()=>{
                            self.checkAutoShowPoker();
                        },true,roomData.roomInfo.state);    
                        this.view.showCowBtn(true);
                    }
                    else{                     
                        this.view.startDealPoker(this.playerInfoMap,0,[],"",()=>{
                            self.sendAck();
                        });
                    }
                    
                    this.comboType = seatInfo.comboType;

                    //this.lockBanker();                    
                    //this.view.showCountDown(info.expire - this.getServerTimeNow());       

                    this.view.showTableTips(false);
                }
                else if(this.roomState == 5){

                    //这里显示结算                                    
                    //显示牌型
                    //this.lockBanker();

                    this.cancelComputerReq();

                    this.view.showTableTips(false);

                    //玩家自己断线重连 走onAgoSettleAccountsBroadcast
                    if(!this.isBattle(this.avatarId)){

                        for (let index = 0; index < roomData.seatInfoList.length; index++) {
                            const seatInfo = roomData.seatInfoList[index];
    
                            if (!this.isBattle(seatInfo.playerId)) continue;
                                                        
                            let seatSide = this.getSeatSide(seatInfo.seatIndex);       
                            this.view.showPlayerResult(seatInfo.playerId,seatSide,seatInfo.comboType,seatInfo.pokers);                     
                        }
                    } 

                    this.view.showRubbing(false);
                }     
                
                if (this.isBattle(this.avatarId)) {                    
                    if (seatInfo.pokers) {                        
                        this.pokers = [];
                        seatInfo.pokers.forEach(poker => {
                            this.pokers.push(poker);    
                        });   
                    }                    
                }

                break;                
                
            }
        }

        if (this.bankerId) {
            
            this.lockBanker();
        }
                
        this.view.updateRoomNum(roomData.roomInfo.roundSign);     
        this.view.updaetRoomStaticLabel(true);
                               
        //与服务器对时
        this.timeOffset = roomData.roomInfo.serverNow * 1000 - Date.now();
            

        this.eventDispatch("Game_Table_Start");

        //默认继续游戏
        //this.model.request_continute();       
    }   



    private updateDizhu(){

        if (!ModelData.instance.roomInfo) return;
        
        let playerRules =  ModelData.instance.roomInfo.PlayRuleData;
        if (playerRules) {
                 
            this.view.updateDizhu(playerRules.game_BetSingle);
            
        }
    }

    private getServerTimeNow(){

        return (this.timeOffset + Date.now()) / 1000 ;
    }    

    private getSeatSide( seatIndex : number ) : number{

        //将avatar的位置归零 来算
        let offset = seatIndex - this.avatarSeat ;

        if (offset < 0) {
            
            return BullBullConst.MAX_SEAT_NUM + offset;
        }
        else{

            return offset;
        }
        
    }

    private updateSeatInfo(playerId : number, seatInfo : RoomProto.BullBullRoom.ISeatInfo ){

        let seatSide =  this.getSeatSide(seatInfo.seatIndex);
        let info = this.getPlayerInfo(playerId);
        if (info) {
            
            info.seatSide = seatSide;
            info.isAvatar = this.avatarId == playerId;        
            info.seatInfo = seatInfo;  
                        
        }
        else{

            this.playerInfoMap[playerId]= new BullBullPlayerInfo(playerId,seatSide,seatInfo);
            this.playerInfoMap[playerId].isAvatar = this.avatarId == playerId;
        }

        
    }

    private removeSeatInfo( playerId ){

        for (const key in this.playerInfoMap) {
            if (this.playerInfoMap.hasOwnProperty(key)) {
                const element = this.playerInfoMap[key];
                
                if (element.playerId == playerId) {
                    
                    delete this.playerInfoMap[key];
                    break;
                }
            }
        }
    }

    private setBattle(playerId ,state : boolean){
        let info = this.getPlayerInfo(playerId);
        if (info) {
            
            info.isBattle = state;
            //遮罩
            this.view.showIconMask(!state,info.seatSide);            
        }        
    }

    private isBattle (playerId : number ) : boolean {

        let info = this.getPlayerInfo(playerId);
        if(!info || !info.isBattle) {
            return false;
        }

        return true;
    }

    private getPlayerInfo(playerId : number ) : BullBullPlayerInfo{

        if (this.playerInfoMap.hasOwnProperty(playerId.toString())) {
            return this.playerInfoMap[playerId.toString()];
        }
        else{
            //cc.error(" can not find playerId " , playerId);
            return null;
        }        
    }

    private getPlayerInfoBySide(seatSide : number){

        for (const key in this.playerInfoMap) {
            if (this.playerInfoMap.hasOwnProperty(key)) {
                const info = this.playerInfoMap[key];
                if(info.seatSide == seatSide){
                    return info;
                }                
            }
        }
        return null;
    }

    private removePlayer(playerId : number ){

        let seatSide = this.getPlayerInfo(playerId).seatSide;
        
        this.view.removeAvatarById(seatSide);

        if (playerId == this.avatarId) {
            
            //自己退出房间
            SceneManager.gotoHallOrClubHall("TabelExit");
            this.playerInfoMap = {};            

        }
        else{

            //其他玩家离开            
            this.view.removePlayer(false,seatSide);

            this.removeSeatInfo(playerId);

            this.checkWating();   
        }
        
    }

    @subscribeMsg(Msg.EnterRsp)
    private onEnterRsp(proto: RoomProto.BullBullRoom.EnterRsp){

        if (proto.errNo == "0") {
            
            if (proto.timeout > 0) {

                this.view.showStartCountDown(proto.timeout);
            }

        }
    }

    /**
     * 收到离开房间消息
     */
    @subscribeMsg(Msg.LeaveRoom)
    private onLeaveRoom(proto: RoomProto.BullBullRoom.LeaveRsp){

        if (proto.errNo != "0") {

            ModuleManager.instance.showModule(DialogLeave);  

            //let text = LanguageManager.t("public_cannotLeave", true);

            //ModuleManager.instance.showModuleName("Toast",{text : text,long : true});
            //ModuleManager.instance.showModuleName("Toast",{text : proto.errNo,long : true});

        }else{

        }

        

        //ModuleManager.instance.hideModule(BullBullConst.MORE_MODULE_NAME);
    }

    /**
     * 座位自定义信息变化广播
     * @param protoData 
     */
    @subscribeMsg(Msg.CustomInfo)
    private onCustomInfo(protoData : RoomProto.BullBullRoom.CustomInfoChangeBroadcast){
        
        let avararId = ModelData.instance.roleData.id;       
        
        for (let index = 0; index < protoData.customInfoList.length; index++) {
            const info = protoData.customInfoList[index];                        

            //this.view.updatePlayerInfo()
        }
    }

    /**
     * 玩家信息同步
     * @param protoData 
     */
    @subscribeMsg(Msg.OneShotSettleNotify)
    private onOneShotSettleNotify(protoData : RoomProto.BullBullRoom.OneShotSettleNotify){

        protoData.oneShotSettlePlayer.forEach(info => {
            
            this.view.updatePlayerInfo(this.getPlayerInfo(info.playerId).seatSide,info.coinBalanceStr,info.playerId);
        });
    }

    /**
     * 新进玩家
     * @param protoData 
     */
    @subscribeMsg(Msg.EnterBroadcast)
    private onEnterBroadcast(protoData : RoomProto.BullBullRoom.EnterBroadcast){

        let seatInfo = new RoomProto.BullBullRoom.SeatInfo();
        seatInfo.seatIndex = protoData.posInfo.posIndex;
        seatInfo.playerId = protoData.posInfo.playerId;
        seatInfo.coinBalanceStr = protoData.oneShotSettlePlayer[0].coinBalanceStr;
        
        this.updateSeatInfo(protoData.posInfo.playerId,seatInfo); 

        let seatSide = this.getPlayerInfo(protoData.posInfo.playerId).seatSide;
        this.view.updatePlayerInfo(seatSide,seatInfo.coinBalanceStr,seatInfo.playerId,"",seatInfo.userJson); 

        this.setBattle(protoData.posInfo.playerId,!this.startGame); 

        this.checkWating();

        
    }

    @subscribeMsg(Msg.ReconnBroadcast)
    private onReconnBroadcast(protoData : RoomProto.BullBullRoom.ReconnBroadcast){

        cc.log("onReconnBroadcast " , protoData.playerId);

        
    }

    /**
     * 开始游戏
     * @param protoData 
     */
    @subscribeMsg(Msg.StartBroadcast)
    private onStartBroadcast(protoData : RoomProto.BullBullRoom.StartBroadcast){

        //开始游戏        

        this.view.startGame();

        this.isSelfPokerBack = false;

        this.startGame = true;

        this.view.playAnimationInNode("anim_niuniu_kaishi");

        let self = this;
        this.doScheduleOnce(()=>{
            self.sendAck();
        },1)

        this.view.updateRoomNum(protoData.roundSign);

        //更新此时所有玩家 进入战斗状态
        for (const key in this.playerInfoMap) {
            if (this.playerInfoMap.hasOwnProperty(key)) {
                const info = this.playerInfoMap[key];                
                this.setBattle(info.playerId,true);
            }
        }

        this.view.hideStartCountDown();                
    }


    @subscribeMsg(Msg.TimeoutNotify)
    private onTimeoutNotify(proto : GameProto.BullBullGame.TimeoutNotify){

        //这里显示开局等待时间
        if (proto.event == 1) {                

            let timeout = proto.timeout - this.getServerTimeNow();
            cc.log(" onTimeoutNotify " , timeout);
            this.view.showStartCountDown(timeout);

            this.isLeaveRoom = false;
            //this.view.hideWating();
        }
        if(proto.ackId){

            this.ackId = proto.ackId;
        }

        //SceneManager.loadingTableModule({seatData : this.playerSeatData});
    }
    

    /**
     * 抢庄回复
     */
    @subscribeMsg(Msg.ScrambleBanker)
    private onScrambleBankerRsp(protoData : GameProto.BullBullGame.ScrambleBankerRsp){

        this.view.showBankerButtons(false);

        this.view.showScramble(this.getPlayerInfo(this.avatarId).seatSide,protoData.isScramble? protoData.multiple : 0);
    }


    private showPokerAniId = 0;
    private checkAutoShowPoker(){
        
        if (this.autoShowPoker) {
                 
            this.view.showCowBtn(false);
            this.view.showCalculate(false);

            this.view.setClickSelfCard(false); 

            let self = this;
            this.showPokerAniId = this.doScheduleOnce(()=>{
                //转牌
                if (self.isWatchAndRob) {
                    self.view.tranferCard();    
                }                                       
                self.reqComputerDelay(1);
            },1)
        }     
    }

    private cancelAutoShowAni(){

        if (this.showPokerAniId > 0) {
            
            this.cancelSchedule(this.showPokerAniId);
        }
    }

    /**
     * 发牌
     * @param proto 
     */
    @subscribeMsg(Msg.DealPoker)
    private onDealPokerBroadcast(proto : GameProto.BullBullGame.DealPokerBroadcast)
    {       
        this.view.hideAllBetButton();    
        this.view.hideCountDown();

        let self = this;
        if (proto.pokers.length == 1){
            //明牌抢庄最后一张
            //this.view.updateLastCard(proto.pokers[0],proto.comboType);
            this.view.startDealPoker(this.playerInfoMap,this.avatarId,proto.pokers,proto.comboType,()=>{
                self.sendAck();

                self.checkAutoShowPoker();               

            });
            
            this.pokers[4] = proto.pokers[0]; 
        }
        else{            

            this.pokers = [];

            proto.pokers.forEach(poker => {
                this.pokers.push(poker);    
            }); 
                
            let self = this;
            this.view.startDealPoker(this.playerInfoMap,this.avatarId,proto.pokers,proto.comboType,()=>{
                self.sendAck();
                //非看牌抢庄
                if (!self.isWatchAndRob) {
                    self.checkAutoShowPoker(); 
                }
            });            
        }                    

        this.comboType = proto.comboType;
                 
    }

    private checkCow() : boolean {        
        return this.comboType != "cow0";
    }

    /**
     * 请求比牌返回
     * @param proto 
     */
    @subscribeMsg(Msg.ComputePoker)
    private onComputePoker(proto : GameProto.BullBullGame.ComputePokerRsp){

        //cc.log(" onComputePoker  "  ,proto.comboType);      
        
        //this.showSelfPokerBack(proto.comboType,this.pokers);

        this.view.showTableTips(true, LanguageManager.t("nn_waitSpelling")  + "...");

    }

    private showSelfPokerBack(comboType : string,pokers : GameProto.BullBullGame.IPoker[]){

        cc.warn("  showSelfPokerBack " ,pokers);

        if (!this.isSelfPokerBack && this.isBattle(this.avatarId) ) {
         
            this.view.showSelfCard(false);
            this.view.showSelfTableCard(0,pokers);

            this.view.showPokerResultAni(this.avatarId,0,comboType,pokers,-1,0);

            //this.view.playCowAni(this.avatarId,0,comboType);
            //this.view.showTableCardBack(0);
            //this.view.showPokerFinish(0,true);        
        }

        this.isSelfPokerBack = true;
    }

    /**
     * 比牌广播
     * @param proto 
     */
    @subscribeMsg(Msg.ComputePokerBroadcast)
    private onComputePokerBroadcast(proto : GameProto.BullBullGame.ComputePokerBroadcast){

        let seatSide = this.getPlayerInfo(proto.playerId).seatSide;

        if (seatSide == 0) {
            
            if (proto.pokers.length) {
                this.pokers = proto.pokers;    

                this.showSelfPokerBack(proto.comboType,this.pokers);
            }

        }else{

            this.view.showPokerFinish(seatSide,true);
        }


        //如果此时有发牌动画没有完成 则立即完成 
        this.view.hidePokerAni(false,seatSide);
    }

    @subscribeMsg(Msg.BetInfo)
    private onBetRsp(proto : GameProto.BullBullGame.BetRsp){

        if (proto.errNo != "0") {
            
            return;
        }
        this.view.hideAllBetButton();

        let seatSide = this.getPlayerInfo(this.avatarId).seatSide;
        this.view.hideScrambleResult(false,seatSide);
        this.view.showBetResult(seatSide,proto.bet);
    }

    @subscribeMsg(Msg.BetTypeBroadcast)
    private onBetTypeBroadcast(proto : GameProto.BullBullGame.BetTypeBroadcast){
  
        if (this.isBattle(this.avatarId)) {
            this.view.showBetButtons(proto.betType);
        }
    }

    
    /**
     * 下注广播
     * @param proto 
     */
    @subscribeMsg(Msg.BetBroadcast)
    private onBetBroadcast(proto : GameProto.BullBullGame.BetBroadcast){

        let seatSide = this.getPlayerInfo(proto.playerId).seatSide;
        this.view.hideScrambleResult(false,seatSide);
        this.view.showBetResult(seatSide,proto.bet);

        //this.unschedule(this.lockBanker);          
    }


    /**
     * 断线重连结算消息
     * @param proto 
     */
    @subscribeMsg(Msg.AgoSettleAccountsBroadcast)
    private onAgoSettleAccountsBroadcast(proto : GameProto.BullBullGame.AgoSettleAccountsBroadcast){

        //需要增加字段,暂屏蔽
        //return;        

        if (this.roomState == 5 && this.isBattle(this.avatarId)) {

            for (let index = 0; index < proto.settleAccounts.length; index++) {
                const seatInfo = proto.settleAccounts[index];
    
                if (!this.isBattle(seatInfo.playerId)) continue;
                                            
                let seatSide = this.getPlayerInfo(seatInfo.playerId).seatSide;
    
                this.view.showPlayerResult(seatInfo.playerId,seatSide,seatInfo.comboType,seatInfo.pokers);
                //更新输赢        
                this.view.turnNum(seatSide,Number(seatInfo.actualWinLoss));

            }
    
        }

        //this.showResult(proto.settleAccounts);
    }

    /**
     * 结算
     * @param proto 
     */
    @subscribeMsg(Msg.SettleAccountsBroadcast)
    private onSettleAccountsBroadcast(proto : GameProto.BullBullGame.SettleAccountsBroadcast){

        //结算状态
        this.roomState = 4;

        this.cancelComputerReq();

        this.view.cancelDealPokerAni();

        this.cancelAutoShowAni();

        this.view.showCowBtn(false);

        this.view.showSelfCard(false);

        this.showResult(proto.settleAccounts);
                
    }

    private showResult( settleActs : GameProto.BullBullGame.ISettleAccounts[]){
    
        cc.log(" showResult " , this.roomState);
        
        let self = this;

        let playerNums = settleActs.length;

        let bankerSide = this.getPlayerInfo(this.bankerId).seatSide;
        
        //this.showSelfPokerBack()

        //隐藏倒计时
        this.view.hideCountDown();  

        this.view.showRubbing(false);

        //按照庄家的顺时针排序
        let delay = 0;

        if (false) {
            //showPokerAni 摊牌动画顺序
            let pokerAnis : GameProto.BullBullGame.ISettleAccounts[] = [];

            for (let index = 0; index < BullBullConst.MAX_SEAT_NUM; index++) {
                pokerAnis[index] = null;            
            }


            for (let index = 0; index < playerNums; index++) {
                const settle = settleActs[index];
                
                let seatSide =  this.getPlayerInfo(settle.playerId).seatSide;            
                    
                if (settle.playerId == this.bankerId) {
                    //庄家最后显示..
                    pokerAnis[BullBullConst.MAX_SEAT_NUM - 1] = settle;

                }else{

                    //从庄家的顺时针依次展示
                    //将庄家的位置放在末尾
                    let offset = seatSide - bankerSide;

                    if (offset < 0) {
                        
                        pokerAnis[BullBullConst.MAX_SEAT_NUM + offset - 1] = settle;
                    }
                    else{

                        pokerAnis[offset - 1] = settle;
                    }

                }                                                                    
            }

            pokerAnis.forEach( (settle,index)=>{
                if (settle) {

                    let seatSide =  this.getPlayerInfo(settle.playerId).seatSide; 
                    
                    if (index < pokerAnis.length - 1) {
                        
                        //闲家一起显示
                        self.view.showPlayerResult(settle.playerId,seatSide,settle.comboType,settle.pokers);

                    }else{

                        delay = 2;
                        this.doScheduleOnce(function(seatSide : number){
                        
                            //庄家最后显示
                            self.view.showPlayerResult(settle.playerId,seatSide,settle.comboType,settle.pokers);
        
                        }.bind(this,seatSide),delay);
                    }                                
                }
            });     

        }else{

            settleActs.forEach((settle)=>{

                if (settle.playerId != this.avatarId) {

                    let seatSide =  this.getPlayerInfo(settle.playerId).seatSide; 
                    
                    if (settle.playerId == this.bankerId) {
                        
                        delay = 2;
                        this.doScheduleOnce(function(seatSide : number){
                        
                            //庄家最后显示
                            self.view.showPlayerResult(settle.playerId,seatSide,settle.comboType,settle.pokers);
        
                        }.bind(this,seatSide),delay);

                    }else{

                        //闲家一起显示
                        this.view.showPlayerResult(settle.playerId,seatSide,settle.comboType,settle.pokers);
                    }

                }else{

                    this.showSelfPokerBack(settle.comboType,settle.pokers);
                }
            });           
        }
    
        
        this.doScheduleOnce(()=>{

            if (self.roomState == 0) {
                return;
            }

            //输赢动画 飘分
            self.view.showWinOrLossAni(self.bankerId,self.avatarId,self.playerInfoMap,settleActs,()=>{
                self.sendAck();
            });

            for (let index = 0; index < playerNums; index++) {
                const settle = settleActs[index];        
                
                let seatSide = self.getPlayerInfo(settle.playerId).seatSide;
                //更新钱币
                //self.view.updatePlayerInfo(seatSide,settle.coinBalanceStr,settle.playerId);
                if (self.avatarId == settle.playerId) {                 
                    UserDataManager.balanceChangeMessage(Number(settle.coinBalanceStr));
                }                
            }          
                         
        },delay + 2.5);     
           
    }
    
    /**
     * 庄家广播
     * @param proto 
     */
    @subscribeMsg(Msg.SetBankerBroadcast)
    private onSetBankerBroadcast(proto : GameProto.BullBullGame.SetBankerBroadcast){

        this.bankerId = proto.playerId;       
                
        let bankerSide = this.getPlayerInfo(this.bankerId).seatSide;

        if(proto.randomBankerList){

            this.view.hideCountDown();

            let interval = 0.2;
            let totalTime = proto.randomBankerList.length > 1 ? 2.8 : -0.2;
            let repeat = Math.round(totalTime / interval);

            let randomBankerList =  proto.randomBankerList.sort((playerA,playerB)=>{

                let seatSideA = this.getPlayerInfo(playerA).seatSide;

                let seatSideB = this.getPlayerInfo(playerB).seatSide;

                return seatSideA - seatSideB;
            });

    
            //this.view.hideScrambleResult(true);

            for (let index = 0; index < randomBankerList.length; index++) {
                const playerId = randomBankerList[index];
                
                //显示随机抢庄的玩家                              
                let seatSide = this.getPlayerInfo(playerId).seatSide;

                this.showIconAniIdList.push( this.doSchedule( 
                    this.showIconFrame.bind(this,seatSide),
                    interval * (randomBankerList.length), // 间隔时间
                    repeat, //重复次数
                    index * interval) //延迟时间
                    );   
                
            }

            
            //最后显示庄家
            let self = this;
            this.doScheduleOnce( ()=>{
                self.lockBanker();
                self.sendAck();
            } ,totalTime + 0.2 );
            //隐藏抢庄按钮
            this.view.showBankerButtons(false);  
        

        }
        else{

            this.showIconFrame(bankerSide);
            //定庄动画
            this.view.addBankerLockAni(bankerSide);      

            this.sendAck();
        }
    }    

    private showIconFrame(seatSide : number){

        this.view.showIconFrame(seatSide);       
    }


    private sendAck(){
        console.warn(" sendAck " , this.ackId);
        this.model.request_ackId(this.ackId);
    }

    /**
     * 定庄
     */
    private lockBanker(){

        let bankerSide = this.getPlayerInfo(this.bankerId).seatSide;

        this.showIconAniIdList.forEach(element => {
           
            this.cancelSchedule(element);
        });        

        this.showIconFrame(bankerSide);

        //定庄动画
        this.view.addBankerLockAni(bankerSide);  


    }

    /**
     * 抢庄广播
     * @param proto 
     */
    @subscribeMsg(Msg.ScrambleBankerBroadcast)
    private onScrambleBankerBroadcast(proto : GameProto.BullBullGame.ScrambleBankerBroadcast){

        
        let self = this;
        let seatSide = this.getPlayerInfo(proto.playerId).seatSide;
        this.view.showScramble(seatSide,proto.isScramble ? proto.multiple : 0);
                
        //this.view.showBankerButtons(false);

    }

    private max_multiple_banker : number = 0;
    // 抢庄通知
    @subscribeMsg(Msg.ScrmbleBankerNotify)
    private onScrmbleBankerNotify(proto : GameProto.BullBullGame.ScrmbleBankerNotify){

        this.max_multiple_banker = proto.maxMultiple;
    }

    /**
     * 离开房间
     * @param protoData 
     */
    @subscribeMsg(Msg.LeaveBroadcast)
    private onLeaveBroadcast(protoData : RoomProto.BullBullRoom.LeaveBroadcast )
    {
        cc.log("  onLeaveBroadcast ",protoData.playerId );
        
        if (this.avatarId == protoData.playerId) {                                  

            this.isLeaveRoom = true;

            if (!joinUtil.checkLeave(protoData.reason,this)) {
            
                if (protoData.reason != 0) {            
                    //自己被T
                    ModuleManager.instance.toastKey("jd_leave" + protoData.reason)                    
                }      
                this.removePlayer(protoData.playerId);  

            }else{

                //seak player..
                this.eventDispatch('update_seek_player',0,0);
            }            
             
        }else{
            this.removePlayer(protoData.playerId);  
        }
        
        
    }

    //牌局重置 
    @subscribeMsg(Msg.ResetBroadcast)
    private onResetBroadcast(protoData : RoomProto.BullBullRoom.ResetBroadcast){        
        
        //发送离开房间
        //this.isReset = true;

        //this.roomState = 6;
        //this.model.request_leave_room();

        //所有schdule清空
        //this.cancelAllSchedule();        
                
        this.unscheduleAllCallbacks();

        this.view.unscheduleAllCallbacks();

        this.view.showRubbing(false);

        this.view.hideResultNode();
        
        //let count = 0;
        for (const key in this.playerInfoMap) {
            if (this.playerInfoMap.hasOwnProperty(key)) {
                const info = this.playerInfoMap[key];
                info.seatInfo.isOffline = 0;
                
                this.setBattle(info.playerId,true);
                
                this.view.resetPlayer(info.seatSide);
                //count++;
            }
        }
        this.reset();      
        
        if (ModelData.instance.tableCommonData.autoLeaveWhenGameEnd) {
            this.model.request_leave_room();
        }

        this.startGame = false;
        
    }

  

    @subscribeMsg(Msg.ReadyInfo)
    private onReadyRsp(protoData : RoomProto.BullBullRoom.ReadyRsp){

        //his.view.showContinueBtn(false);
    }

    @subscribeMsg(Msg.ReadyBroadcast)
    private onReadyBroadcast(protoData : RoomProto.BullBullRoom.ReadyBroadcast){

        if (protoData.posInfo.playerId == this.avatarId && protoData.posInfo.isReady == 1) {
            
            //this.view.showContinueBtn(false);
        }
    }

    @subscribeMsg(Msg.KickPlayerBroadcast)
    private onKickPlayerBroadcast(protoData : RoomProto.BullBullRoom.KickPlayerBroadcast){

        this.removePlayer(protoData.playerId);
    }


    @subscribeMsg(Msg.SynExpireBroadcast)
    private onSynExpireBroadcast(protoData : RoomProto.BullBullRoom.SynExpireBroadcast){

        //(state 0:房间等待准备状态 1:定庄状态 2:下注状态 3:等待结算状态,5:结算超时 8:游戏已经开始，但还未开始抢庄)
        //list?
        let self = this;
        protoData.expires.forEach(info => {
            
            this.roomState = info.state;

            switch (info.state) {
                case 0:                                        
                    this.view.hideCountDown();
                    
                    this.view.showAutoPoker(false);
                    break;
                case 8:
                    this.view.hideCountDown();

                    break;    
                case 1:        
                    if(this.isBattle(this.avatarId) ){
                        
                        this.doSchedule(()=>{
                            
                            self.view.showBankerButtons(true,this.max_multiple_banker);   
                            //self.view.autoNode.active = true;
                            self.view.setAutoToggle(this.autoShowPoker);

                        },this.isWatchAndRob ? 1.3 : 0)

                    }
                    this.view.showCountDown(info.expire - this.getServerTimeNow());   
                    

                    break;
                case 2:                    
                    if (this.avatarId == this.bankerId) {                        
                        this.view.showTableTips(true,LanguageManager.t("nn_waitBetting") + "...");
                        this.view.hideAllBetButton();
                    }

                    this.hideSrambleExceptBanker();

                    this.view.showBankerButtons(false);    
                    this.view.showCountDown(info.expire - this.getServerTimeNow());  

                    if(this.isBattle(this.avatarId)){
                        //this.view.autoNode.active = true;
                        this.view.setAutoToggle(this.autoShowPoker);
                    }
                    
                    break;
                case 3:                        
                    let delay = info.expire - this.getServerTimeNow();
                    //cc.log(" showSelfPokerBack delay " , delay);
                    this.view.showBankerButtons(false);    
                    this.view.hideAllBetButton();
                    this.view.showTableTips(false);
                    this.view.showCountDown(delay);  

                    if(this.isBattle(this.avatarId)){      
                        this.view.showAutoPoker(false);
                    }
                    

                    let avatarInfo = this.playerInfoMap[this.avatarId.toString()];
                    if (avatarInfo && avatarInfo.isBattle) { 
                        this.view.showCowBtn(true);
                    }
                                                         

                    // let avatarInfo = this.playerInfoMap[this.avatarId.toString()];
                    // if (avatarInfo && avatarInfo.isBattle) {   
                    //     let self = this;                  
                    //     this.doScheduleOnce(()=>{
                    //         //self.showSelfPokerBack(self.comboType,self.pokers);       
                    //     },delay)

                    //     this.view.showCowBtn(true);

                    // }else{                     
                    //     this.view.startDealPoker(this.playerInfoMap,[],"",()=>{
                    //         self.sendAck();
                    //     });
                    // }
                    break;
                case 5:
                    this.view.hideCountDown();       
                    break;    
                default:
                    break;
            }                    

            //this.view.showCountDown(info.expire - this.getServerTimeNow());  
                   
        });
    }

    private hideSrambleExceptBanker(){

        for (const key in this.playerInfoMap) {                
            if (this.playerInfoMap.hasOwnProperty(key)) {
                const playerInfo = this.playerInfoMap[key];  

                if (playerInfo.playerId == this.bankerId) {
                    continue;
                }

                this.view.hideScrambleResult(false,playerInfo.seatSide);
            }
        }
    }


    private checkWating(){

        cc.warn(" checkWating ...");
        let count = 0
        for (const key in this.playerInfoMap) {
            count++;
        }

        //最小开局人数
        let roomData = ModelData.instance.roomInfo.PlayRuleData;

        //检测玩家        
        if (count < Number(roomData.pub_MinPlayerNum)) {    

            this.eventDispatch('update_seek_player',count,Number(roomData.pub_MinPlayerNum));

            this.view.hideStartCountDown();
            //this.view.startWating();            
        }else{

            this.eventDispatch('update_seek_player',0,0);

            //this.view.hideWating();
        }
    }

    private reset(){

        this.roomState = 0;
        this.isSelfPokerBack = false;

        if (this.view) {
         
            this.view.resetTable();
        }       
        
    }


}

